import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function FixTab() {
    const { useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('offgrid');
    const tabs: any = [
        { text: t('fix_tab1'), id: '#off-grid-B', key: 0 },
        { text: t('fix_tab2'), id: '#off-grid-C', key: 1 },
        { text: t('fix_tab3'), id: '#off-grid-D', key: 2 },
        { text: t('fix_tab4'), id: '#off-grid-F', key: 3 },
        { text: t('fix_tab5'), id: '#off-grid-O', key: 4 },
        { text: t('fix_tab6'), id: '#off-grid-P', key: 5 },
        { text: t('fix_tab7'), id: '#off-grid-Q', key: 6 },
        { text: t('fix_tab8'), id: '#off-grid-R', key: 7 },
    ];
    const [fixH, setFixH] = useState(0);
    const [activeTab, setActiveTab] = useState(tabs[0]?.id);
    const handleClickTab = (id: string) => {
        setActiveTab(id);
    };

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         const resizeFunc = () => {
    //             const target = document.querySelector('.off-grid-fix-tab .tabs-box') as HTMLUListElement;
    //             target.style.transition = 'left .4s ease';
    //             // if (
    //             //     target.offsetWidth > window.innerWidth &&
    //             //     !['#off-grid-G', '#off-grid-O', '#off-grid-P', '#off-grid-Q', '#off-grid-R'].includes(activeTab)
    //             // ) {
    //             //     target.style.left = `${window.innerWidth - target.offsetWidth}px`;
    //             // } else {
    //             //     target.style.left = `${0}px`;
    //             // }
    //             setTimeout(() => {
    //                 target.style.transition = 'none';
    //             }, 400);
    //         };
    //         resizeFunc();
    //         window.addEventListener('resize', resizeFunc);
    //         return () => window.removeEventListener('resize', resizeFunc);
    //     }
    // }, [activeTab]);

    useEffect(() => {
        const scrollFunc = (id: string) => {
            const target = document.querySelector(id) as HTMLDivElement;
            if (target) {
                AniContainer.create({
                    triggerElement: id,
                    triggerHook: 1,
                    offset: '50%',
                    duration: target?.offsetHeight,
                    onEnter: () => setActiveTab(id),
                });
            }
        };

        const ids: string[] = ['#off-grid-B', '#off-grid-C', '#off-grid-D', '#off-grid-F', '#off-grid-O', '#off-grid-P', '#off-grid-Q'];
        ids.forEach((id: string) => scrollFunc(id));

        AniContainer.create({
            triggerElement: '#off-grid-R',
            triggerHook: 1,
            offset: '50%',
            onEnter: () => setActiveTab('#off-grid-R'),
        });

        setTimeout(() => {
            const bar = document.querySelector('.announcement-bar') as HTMLElement;
            if (bar) {
                const styles = window.getComputedStyle(bar);
                const position = styles.position;
                setFixH(Number(position === 'sticky' ? bar?.offsetHeight : 0) || 0);
            }
        }, 3000);
    }, []);

    return (
        <div className={`off-grid-fix-tab ${css['off-grid-fix-tab']}`} style={{ top: `${fixH}px` }}>
            <div className="tabs-wrapper">
                <ul className="tabs-box" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                    {tabs?.map((tab: any, k: number) => (
                        <a className={`tab ${activeTab === tab?.id ? 'active' : ''}`} href={tab?.id} key={tab?.id} onClick={() => handleClickTab(tab?.id)}>
                            {tab?.text}
                        </a>
                    ))}
                </ul>
            </div>
        </div>
    );
}
